// this file contains a list of all uris that can be accessed by the various actions
export const API_HOST = process.env.ENDPOINT + ":" + process.env.PORT;
export const BASE_URI = API_HOST + "/v1";

export const COOKIES_URI = BASE_URI + "/cookies";
